import styled from 'foundations-theming/utils';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { Gates, isUngatedFor } from '../utils/auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const OldLoadingSkeleton = styled.div.withConfig({
  displayName: "LoadingSkeleton__OldLoadingSkeleton",
  componentId: "sc-5zmpl9-0"
})(["height:60px;border-radius:30px;background-image:radial-gradient( at 16% 0%,", ",transparent 50% ),radial-gradient( at 85% 7%,", ",transparent 50% ),radial-gradient( at 100% 48%,", ",transparent 50% ),radial-gradient( at 100% 100%,", ",transparent 50% ),radial-gradient( at 55% 100%,", ",transparent 50% ),radial-gradient( at 2% 97%,", ",transparent 50% );background-size:150% 150%;animation:pulse alternate-reverse 1.5s infinite;@keyframes pulse{0%{opacity:0.25;}100%{opacity:1;}}"], ({
  theme
}) => theme.color['do-not-use-norman'], ({
  theme
}) => theme.color['do-not-use-sorbet'], ({
  theme
}) => theme.color['do-not-use-marigold'], ({
  theme
}) => theme.color['do-not-use-oz'], ({
  theme
}) => theme.color['do-not-use-calypso'], ({
  theme
}) => theme.color['do-not-use-thunderdome']);
const LoadingSkeleton = props => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isUngatedFor(Gates.BREEZE_AI_REBRANDING) ? /*#__PURE__*/_jsx(AISkeleton, Object.assign({
      shape: "pill"
    }, props, {
      height: 60
    })) : /*#__PURE__*/_jsx(OldLoadingSkeleton, Object.assign({}, props))
  });
};
export default LoadingSkeleton;